import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  FeatureValidation,
  ProjectsFacade,
  debounce,
  formatNumber,
  getRolesAndPermission,
  greaterThanZeroValidator,
  isFeatureEnabled,
  noWhitespaceValidator,
  onKeyDown,
  scrollToSpecific,
  showFeatureAlert,
  validateFeatures,
} from '@piqet-angular/data';
import {
  AccessPermissionService,
  CustomModalService,
  DistanceTypeEnum,
  FeatureCodes,
  commonEnum,
  mainModuleName,
  rolesModuleName,
} from '@piqet-angular/shared';
import { ActionButtonComponent } from '../action-button/action-button.component';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { ProjectPackMaterialListDataGridService } from 'libs/features/src/lib/layout/projects/project-details/project-material-list/project-material-list-data-grid.service';
import { NewProjectInlineDropdownComponent } from '../new-project-inline-dropdown/new-project-inline-dropdown.component';
import { cloneDeep } from 'lodash';
import { GridProjectAutocompleteComponent } from '../grid-project-autocomplete/grid-project-autocomplete.component';
import { TitleCasePipe } from '@angular/common';
import { CustomService } from 'libs/data/src/lib/services/custom/custom.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import {
  Observable,
  Subject,
  Subscription,
  catchError,
  debounceTime,
  distinctUntilChanged,
  forkJoin,
  of,
  take,
} from 'rxjs';
import { GridCellInfoComponent } from '../grid-cell-info/grid-cell-info.component';
import { ToastrService } from 'ngx-toastr';
import { MapsAPILoader } from '@agm/core';
import { InlineActionButtonComponent } from '../inline-action-button/inline-action-button.component';
import { MyOrganizationService } from 'libs/data/src/lib/services/my-organization/my-organization.service';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { GuideTourEnum, DISTANCE_KM_LABEL } from '@piqet-angular/shared';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { DecimalFormatPipePipe } from 'libs/shared/src/lib/pipes/decimal-format-pipe.pipe';

@Component({
  selector: 'piqet-angular-new-project-material',
  templateUrl: './new-project-material.component.html',
  styleUrls: ['./new-project-material.component.scss'],
  providers: [TitleCasePipe],
})
export class NewProjectMaterialComponent implements OnInit, OnDestroy {
  DISTANCE_KM_LABEL = DISTANCE_KM_LABEL;
  projectPackMaterialForm!: FormGroup;
  materialDetailForm: any;
  componentDetailForm: any;
  pageNumber: number = 1;
  transportationDetailForm: any;
  conversionDetailForm: any;
  CustomtransportScenarioId: any;
  noRecycledContents: any;
  isDisableRecycledContent = false;
  distanceBlack = './assets/icons/BasedOnDistance.png';
  distanceWhite = './assets/icons/BasedOnDistanceWhite.png';
  locationBlack = './assets/icons/BasedOnLocations.png';
  loactionWhite = './assets/icons/BasedOnLocationsWhite.png';
  customBlack = './assets/icons/CustomScenarios.png';
  customWhite = './assets/icons/CustomScenariosWhite.png';
  keyword = 'name';
  allCountriesFilterData: any;
  cityWithPort: any;
  isShowPort = false;
  supplierId: any;
  selectedCities: any;
  originId: any;
  packMaterialData: any;
  processColumnDef: any;
  distanceProcessColumnDef: any;
  conversionProcessColumnDef: any;
  modalLabel: any;
  packageLevel: any;
  supplier: any;
  materialItems: any;
  customMaterialItems: any;
  materialRegion: any;
  transportModeItems: any;
  materialInfoData: any;
  isHideShowMaterialContent = false;
  setDestinationsubmitted = false;
  setManualDistanceSubmitted = false;
  isAreaBaseConversionProcess = false;
  isRecommendedConversionProcess = false;
  isCustomConversion = false;
  isCustomTruck = false;
  percenteageMassLoad: any;
  setOriginsubmitted = false;
  addConversionSubmitted = false;
  checkAddCustomFreight = false;
  isShowDistantField = false;
  setApiResDistance = false;
  transportModeId: any;
  transportModeName: any;
  transportModeDescription: any;
  areaConversionItems: any;
  destinationData: any;
  conversionData: any;
  transportScenarioDataForDistance: any;
  conversionProcessItems: any;
  conversionNoSelectedProcessItems: any;
  conversionRegion: any;
  customTruckItems: any;
  scenarioId: any;
  packageLevelIdData: any;
  customConversionItems: any;
  customtransportScenarioItems: any;
  transportaionId: any;
  isCustomMaterial: any;
  transportScenarioData: any = {
    transportModeId: 0,
    transportModeName: '',
    cityName: '',
    distance: '',
    originId: '',
  };
  submittedForComponent = false;
  submittedForMaterial = false;
  isShowCustomTransportList = false;
  customTransportList: any;
  customTransportDef: any;
  materialCountryData: any;
  conversionCountryData: any;
  selectedBox: any;
  customMaterialData: any;
  selectCustom = false;
  selectDistance = false;
  selectLocation = false;
  isCostTrunOff = false;
  materialCost: any;
  lastItem: any;
  messageType: any;
  isValidPort: any;
  isLoading = false;
  isLoadingSupplier = false;
  isCheckAreaConversion!: boolean;
  showCustomMaterialAccess: boolean = false;
  showCustomTruckAccess: boolean = false;
  showCustomConversionAccess: boolean = false;
  showCustomTransportAccess: boolean = false;
  FeatureCodes = FeatureCodes;
  isMaterialFeatureDisabled: boolean = false;

  @ViewChild('auto') auto: any;
  @ViewChild('autoForOrigin') autoForOrigin: any;
  @ViewChild('autoForDestination') autoForDestination: any;
  @ViewChild('popoverOne') popoverOne!: NgbPopover;
  @ViewChild('popoverTwo') popoverTwo!: NgbPopover;
  @ViewChild('popoverThree') popoverThree!: NgbPopover;
  @ViewChild('popoverFour') popoverFour!: NgbPopover;
  @ViewChild('popoverFive') popoverFive!: NgbPopover;
  searchValue: any;
  subscriptionInlineCheck!: Subscription;
  subscriptionSaveProjectManualDistanceDataData!: Subscription;
  conversionProcessColumn: any;
  isCheckUpdateDestination = false;
  isCheckUpdateOrigin = false;
  @Output() saveNewMyProjectPackMaterialEvent = new EventEmitter<any>();
  subscriptionProjectMaterialData!: Subscription;
  projectMaterialeditData: any;
  seaDistance: any;
  frameworkComponents = {
    inlineActionButtonComponent: InlineActionButtonComponent,
  };
  frameworkComponentsForConversion = {
    actionRenderer: ActionButtonComponent,
    newProjectInlineDropdownComponent: NewProjectInlineDropdownComponent,
    gridProjectAutocompleteComponent: GridProjectAutocompleteComponent,
    gridCellInfoComponent: GridCellInfoComponent,
  };
  wholeData: any = [
    {
      displayName: 'Based on locations',
      img: this.locationBlack,
      widthImg: 19,
      heightImg: 26,
      type: 'location',
      transportaionId: 2,
    },
    {
      displayName: 'Based on distances',
      img: this.distanceBlack,
      widthImg: 26,
      heightImg: 25,
      type: 'distance',
      transportaionId: 3,
    },
    {
      displayName: 'Custom freight scenarios',
      img: this.customBlack,
      widthImg: 22,
      heightImg: 26,
      type: 'custom',
      transportaionId: 4,
    },
  ];
  TransportationEnum = [
    { Description: 'Material Default', id: 1 },
    { Description: 'Manual Locations', display: 'location', id: 2 },
    { Description: 'Manual Distances', display: 'distance', id: 3 },
    { Description: 'Custom Transport Mode', display: 'custom', id: 4 },
  ];

  recyclableComponentList: any;
  materialInfoDataKey: any;
  materialInfoDataValues: any;
  materialname: any;
  recylcableComponent: any;
  showRecycledContent: boolean = true;
  setDestinationLocationData: any;
  getOriginAndDestinationEditData: any;
  checkIsOrginBtn = true;
  subscriptionCheckDeleteRowData!: Subscription;
  subscriptionProjectMaterialManudalDistanceData!: Subscription;
  clearInputFieldProjectManualDistance!: Subscription;
  projectMaterialeditManualDistanceData: any;
  isCheckEditManudalDist = false;
  setManualLocationDis: any;
  setManualLocationDisForNextRecord: any;
  carbonNeutralValue: any;
  fscCertificationValue: any;
  otherCertificationValue: any;
  certificateData: any;
  roleName?: string;
  customFreightSelectData: any;
  searchSupplierList: any;
  organizationRecycleContent: any;
  private searchSubject = new Subject<string>();
  private readonly debounceTimeMs = 300; // Set the debounce time (in milliseconds)
  search$!: Observable<string>;
  keywordAuto: string = '';
  selectedSupplier: any;
  currrencyName: string;
  isBookmarked: boolean = false;
  bookmarkedComponentList: any;
  showEdit: boolean = false;

  componentDataSourceList: any[] = [];
  isComponentLoading: boolean = false;
  componentDataSourceId: number | null = null;
  componentDataSource: any = null;
  selectedComponentDataSource: any;

  decimalFormatPipePipe = new DecimalFormatPipePipe();
  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    public projectFacde: ProjectsFacade,
    private projectService: ProjectsService,
    private toaster: ToastrService,
    private projectPackMaterialListDataGridService: ProjectPackMaterialListDataGridService,
    private titleCasePipe: TitleCasePipe,
    private sharedService: SharedService,
    private customService: CustomService,
    private mapsAPILoader: MapsAPILoader,
    private myOrganizationService: MyOrganizationService,
    private accessService: AccessPermissionService,
    private readonly swalService: SwalService
  ) {
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.packMaterialData =
      this.modal?.modalService?.config?.initialState?.['newMyProjectsPackMaterial'];
    this.processColumnDef =
      this.projectPackMaterialListDataGridService.getTransportModalForManualLocationDataColumn();
    (this.distanceProcessColumnDef =
      this.projectPackMaterialListDataGridService.getTransportModalForManualDestinationDataColumn()),
      (this.customTransportDef =
        this.modal?.modalService?.config?.initialState?.['customTransportColumnDef']);
    this.packageLevel = this.packMaterialData.packagingLevels.sort(
      (a: any, b: any) => a.packagingLevelId - b.packagingLevelId
    );
    this.recyclableComponentList = this.packMaterialData.recylcableComponentItems;
    this.organizationRecycleContent = this.packMaterialData.organizationRecycleContent;
    this.supplier = this.packMaterialData.suppliersItems;
    this.componentDataSource = this.packMaterialData?.componentDataSourceItems;
    this.materialItems = this.packMaterialData.materialItems;
    this.currrencyName = this.packMaterialData.currrencyName;
    this.customMaterialItems = this.packMaterialData.customMaterialItems;
    this.materialRegion = this.packMaterialData.materialRegion;
    this.transportModeItems = this.packMaterialData.transportModeItems;
    this.conversionProcessItems = this.packMaterialData.processItems;
    this.areaConversionItems = this.packMaterialData.areaConversionItems;
    this.conversionRegion = this.packMaterialData.conversionRegion;
    this.customTruckItems = this.packMaterialData.customTruckItems;
    this.customConversionItems = this.packMaterialData.customConversionItems;
    this.customtransportScenarioItems = this.packMaterialData.customtransportScenarioItems;
    this.CustomtransportScenarioId = this.packMaterialData?.customtransportScenarioId;
    this.checkAddCustomFreight = !!this.CustomtransportScenarioId ? true : false;
    this.scenarioId = this.packMaterialData.scenarioId;
    this.isCustomMaterial = this.packMaterialData.isCustomMaterial;
    this.isAreaBaseConversionProcess = this.packMaterialData.isAreaConversionProcess;
    this.isRecommendedConversionProcess = this.packMaterialData.isRecommendedConversionProcess;
    this.isDisableRecycledContent = this.packMaterialData.isDisableRecycledContent;
    this.conversionProcessColumnDef =
      this.projectPackMaterialListDataGridService.getConversionProcessDataColumn();
    if (this.packMaterialData.conversionProcessItems.length > 0) {
      this.conversionProcessColumnDef.find((x: any) => x.headerName == 'Area').hide =
        this.packMaterialData.conversionProcessItems.filter((x: any) => x.areaBaseConversionProcess)
          .length > 0
          ? false
          : true;
      this.conversionProcessColumnDef.find((x: any) => x.headerName == 'Area').editable =
        this.packMaterialData.conversionProcessItems.filter((x: any) => x.areaBaseConversionProcess)
          .length > 0
          ? true
          : false;
    }
    this.isCustomConversion = this.packMaterialData.isCustomConversion;
    if (
      !this.isRecommendedConversionProcess &&
      !this.isAreaBaseConversionProcess &&
      !this.isCustomConversion
    ) {
      this.projectService.getAllOrganizationConversionProcess().subscribe((data: any) => {
        this.conversionNoSelectedProcessItems = data.data;
      });
    }
    this.customTransportList = this.packMaterialData.customTransoportScenarioDetailViewModels;
    this.isCostTrunOff = !this.packMaterialData.isCostTrunOff;
    this.conversionProcessColumnDef.find(
      (x: any) => x.headerName == 'Cost of conversion per kg'
    ).hide = !this.isCostTrunOff;
    this.materialCost = this.packMaterialData.materialCost;
    this.getPackageLevel();
    this.isCustomMaterial ? this.getCustomMaterialName() : null;
    this.getMaterialCountry();
    this.getConversionCountry();
    this.recycableComponent();
    const materialDummyObj: any = {};
    materialDummyObj['id'] = this.packMaterialData.materialId;
    !this.packMaterialData.isAreaConversionProcess &&
      !this.packMaterialData.isCustomConversion &&
      this.getConversionProcess(materialDummyObj, true);
  }

  getCustomFreight() {
    this.packMaterialData.customtransportScenarioItems.find((x: any) => {
      if (this.CustomtransportScenarioId == x.id) {
        this.customFreightSelectData = x;
        this.addCustomFreight();
        this.transportationDetailForm.patchValue({ customScenarioItem: x });
      }
    });
  }

  async fingOriginAndDestination(id: any) {
    this.getOriginAndDestinationEditData = id;
    if (this.checkIsOrginBtn) {
      this.isCheckUpdateOrigin = true;
      this.transportationDetailForm.patchValue({ Origin: this.getOriginAndDestinationEditData });
    } else {
      this.isCheckUpdateDestination = true;
      this.transportationDetailForm.patchValue({
        destination: this.getOriginAndDestinationEditData,
      });
    }
  }

  ngOnInit(): void {
    this.isMaterialFeatureDisabled = !isFeatureEnabled(
      FeatureCodes.MATERIAL_MATERIAL_CERTIFICATION
    );
    (this.showEdit = this.accessService.hasPermission('edit', '', 'packaging')),
      (this.showCustomMaterialAccess = getRolesAndPermission(
        rolesModuleName.customMaterial,
        mainModuleName.customModule
      )?.isOverview);
    this.showCustomConversionAccess = getRolesAndPermission(
      rolesModuleName.customConversion,
      mainModuleName.customModule
    )?.isOverview;
    this.showCustomTruckAccess = getRolesAndPermission(
      rolesModuleName.customTrucks,
      mainModuleName.customModule
    )?.isOverview;
    this.showCustomTransportAccess = getRolesAndPermission(
      rolesModuleName.customTransportScenario,
      mainModuleName.customModule
    )?.isOverview;
    this.projectFacde.projectPackMaterialTransportScenarioList$
      .pipe(take(1))
      .subscribe((data: any) => {
        this.checkIsOrginBtn = false;
      });

    if (this.modalLabel.toLowerCase() == 'add component details') {
      this.projectService.getBookmarkedComponentList().subscribe((data: any) => {
        this.bookmarkedComponentList = data.data?.componentList;
      });
    }

    this.search$ = debounce(this.searchSubject.asObservable(), this.debounceTimeMs);
    this.search$.subscribe(searchValue => {
      this.searchCities(searchValue);
    });

    this.subscriptionCheckDeleteRowData =
      this.projectPackMaterialListDataGridService.checkDeleteRowData$.subscribe((check: any) => {
        this.transportationDetailForm.controls['Origin'].setValue(null);
        this.transportationDetailForm.controls['destination'].setValue(null);
        this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
        this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
        this.transportationDetailForm.controls['distance'].setValue('');
        this.isCheckUpdateDestination = false;
        this.isCheckUpdateOrigin = false;
        this.isCheckEditManudalDist = false;
        check[2] && check[0].length > 0 && this.deleteSetDistanceRecord(check[0], check[1]);
      });
    this.clearInputFieldProjectManualDistance =
      this.projectPackMaterialListDataGridService.clearInputFieldProjectManualDistance$.subscribe(
        (check: any) => {
          this.transportationDetailForm.controls['Origin'].setValue(null);
          this.transportationDetailForm.controls['destination'].setValue(null);
          this.transportationDetailForm.controls['transportModeForLocation'].reset();
          this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
          this.transportationDetailForm.controls['distance'].setValue('');
          this.isCheckUpdateDestination = false;
          this.isCheckUpdateOrigin = false;
          this.isCheckEditManudalDist = false;
          this.checkIsOrginBtn = false;
        }
      );
    this.subscriptionProjectMaterialManudalDistanceData =
      this.projectPackMaterialListDataGridService.editProjectMaterialManualDistanceSubData$.subscribe(
        (editData: any) => {
          this.projectMaterialeditManualDistanceData = editData;
          this.isCustomTruck = editData.isCustomTruck;
          this.transportModeId = editData.transportModeId;
          this.isCheckEditManudalDist = true;
          this.transportationDetailForm.controls['distance'].setValue(editData.distance);
          const location = editData.isCustomTruck ? this.customTruckItems : this.transportModeItems;
          const locationId = editData.isCustomTruck
            ? editData.customTruckId
            : editData.transportModeId;
          location.map((x: any) => {
            if (x.id == locationId) {
              this.setDestinationLocationData = x;
              this.transportationDetailForm.patchValue({
                transportModeForDistance: this.setDestinationLocationData,
              });
            }
          });
        }
      );

    this.subscriptionSaveProjectManualDistanceDataData =
      this.projectPackMaterialListDataGridService.saveProjectManualDistanceData$.subscribe(
        (editData: any) => {
          this.projectFacde.projectPackMaterialTransportScenarioList$
            .pipe(take(1))
            .subscribe(async (data: any) => {
              data?.length == 1 && editData[1] == 'manualLocation'
                ? this.setOrigin(null)
                : editData[1] == 'manualLocation'
                ? this.setDestination()
                : this.addTransportDistance();
            });
        }
      );
    this.subscriptionProjectMaterialData =
      this.projectPackMaterialListDataGridService.editProjectMaterialSubData$.subscribe(
        async (editData: any) => {
          this.projectMaterialeditData = editData[0];
          this.isCustomTruck = editData[0].isCustomTruck;
          this.transportModeId = editData[0].transportModeId;
          const distanceManualLocationvalue =
            typeof editData[0].distance === 'string'
              ? editData[0]?.distance?.substring(0, editData[0]?.distance?.indexOf(' '))
              : 0;
          this.transportationDetailForm.controls['distanceManulaLocation'].setValue(
            distanceManualLocationvalue
          );
          if (editData[1]) {
            this.projectFacde.projectPackMaterialTransportScenarioList$
              .pipe(take(1))
              .subscribe(async (data: any) => {
                this.checkIsOrginBtn = data.length <= 1 ? true : false;
              });
            editData[0] = { ...editData[0] };
            editData[0].name = editData[0].originName;
            await this.fingOriginAndDestination(editData[0]);
            this.getLastItem();
            const location = editData[0].isCustomTruck
              ? this.customTruckItems
              : this.transportModeItems;
            const locationId = editData[0].isCustomTruck
              ? editData[0].customTruckId
              : editData[0].transportModeId;
            location.map((x: any) => {
              if (x.id == locationId) {
                this.setDestinationLocationData = x;
                this.transportationDetailForm.patchValue({
                  transportModeForLocation: this.setDestinationLocationData,
                });
              }
            });
          }
        }
      );
    this.projectPackMaterialForm = this.formBuilder.group({
      componentDetailForm: this.formBuilder.group({
        componentName: [
          this.packMaterialData.name || null,
          [Validators.required, noWhitespaceValidator, Validators.maxLength(50)],
        ],
        packagingLevels: [null, Validators.required],
        Supplier: [this.packMaterialData.materialSupplierName || null],
        componentDataSource: [this.packMaterialData?.componentDataSourceName || null],
      }),
      materialDetailForm: this.formBuilder.group({
        materialName: [null, Validators.required],
        materialCountry: [null],
        materialCost: [this.materialCost || 0.0, Validators.min(0)],
        materialWeigth: [
          this.packMaterialData.materialWeight || '',
          [
            Validators.required,
            Validators.maxLength(100),
            greaterThanZeroValidator(),
            noWhitespaceValidator,
          ],
        ],
        materialRecycledContent: [
          this.decimalFormatPipePipe.transform(Number(this.packMaterialData.recycledContent)) ||
            0.0,
        ],
        recyclableComponent: [null], // NEW DROPDOWN
      }),
      transportationDetailForm: this.formBuilder.group({
        Origin: [null],
        destination: [null],
        transportModeForLocation: [null],
        transportModeForDistance: [null],
        distanceManulaLocation: [''],
        distance: [''],
        customScenarioItem: [null],
      }),
      conversionDetailForm: this.formBuilder.group({
        conversion: [null],
        isRecommendedConversionProcess: [true],
        isAreabasedConversion: [false],
        isCustomConversion: [false],
        area: [this.packMaterialData.areaBaseConversionProcess || ''],
        converter: [null],
        country: [null],
        conversionCost: [''],
      }),
    });
    this.supplierId = this.packMaterialData.materialSupplierId;
    this.componentDataSourceId = this.packMaterialData.componentDataSourceId;
    this.componentDetailForm = this.projectPackMaterialForm.controls['componentDetailForm'];
    this.materialDetailForm = this.projectPackMaterialForm.controls['materialDetailForm'];
    this.transportationDetailForm =
      this.projectPackMaterialForm.controls['transportationDetailForm'];
    this.conversionDetailForm = this.projectPackMaterialForm.controls['conversionDetailForm'];
    this.setFormData();
    this.materialInfo();
    this.conversionProcessColumnDef.find((x: any) => x.headerName == 'Country').cellRendererParams[
      'conversionRegion'
    ] = this.conversionRegion;
    this.conversionProcessColumnDef.find(
      (x: any) => x.headerName == 'Converter'
    ).cellRendererParams['supplier'] = this.supplier;
    !!this.CustomtransportScenarioId && this.getCustomFreight();
    this.subscriptionInlineCheck =
      this.projectPackMaterialListDataGridService.areaHideShowCheckSuccessData$.subscribe(() => {
        this.checkAreaFieldHideShow();
      });
  }

  checkAreaFieldHideShow() {
    this.projectFacde.getConversionList$.subscribe((data: any) => {
      this.conversionProcessColumnDef.find((x: any) => x.headerName == 'Area').hide = data.find(
        (x: any) => x.isAreaBaseConversionProcess
      )
        ? false
        : true;
      this.conversionProcessColumnDef.find((x: any) => x.headerName == 'Area').editable = data.find(
        (x: any) => x.isAreaBaseConversionProcess
      )
        ? true
        : false;
      this.conversionProcessColumn = cloneDeep(this.conversionProcessColumnDef);
      this.conversionProcessColumnDef = this.conversionProcessColumn;
    });
  }

  commonInputSearch(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }

  commonInputSearchForName(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  async getPackageLevel() {
    await this.packageLevel.map((item: any) => {
      if (item.packageLevelInfoId == this.packMaterialData.packageLevelId) {
        return (this.packageLevelIdData = item);
      }
    });
  }

  async recycableComponent() {
    let recyclableComponentId = this.packMaterialData.recylcableComponent || 1; // material default value;
    await this.recyclableComponentList.map((item: any) => {
      if (item.id == recyclableComponentId) {
        return (this.recylcableComponent = item);
      }
    });
  }

  async getCustomMaterialName() {
    await this.customMaterialItems.map((item: any) => {
      if (item.id == this.packMaterialData.customMaterialId) {
        return (this.customMaterialData = item);
      }
    });
  }

  async getMaterialCountry() {
    await this.materialRegion.map((item: any) => {
      if (item.id == this.packMaterialData.materialCountryId) {
        if (item.name == 'USA minor outlying islands') item.name = 'USA Minor Outlying Islands';
        return (this.materialCountryData = item);
      }
    });
  }

  async getConversionCountry() {
    await this.conversionRegion.map((item: any) => {
      if (item.id == this.packMaterialData.conversionCountryId) {
        this.conversionCountryData = {
          ...item,
          name:
            item.name == 'EU' || item.name == 'USA' || item.name == 'USA Minor Outlying Islands'
              ? item.name
              : this.titleCasePipe.transform(item.name),
        };
      }
    });
  }

  setFormData() {
    this.carbonNeutralValue = this.packMaterialData?.carbonNeutral;
    this.fscCertificationValue = this.packMaterialData?.fscCertification;
    this.otherCertificationValue = this.packMaterialData?.otherCertification;
    this.roleName = this.sharedService.decodeString(this.packMaterialData?.roleName);
    this.certificateData = this.packMaterialData?.lstOrganizationCertificationViewModel;
    this.componentDetailForm.patchValue({
      packagingLevels: this.packageLevelIdData,
    });
    this.materialDetailForm.patchValue({
      recyclableComponent: this.recylcableComponent,
    });
    this.materialDetailForm.patchValue({
      materialCountry: this.materialCountryData,
    });
    this.isCustomMaterial
      ? this.materialDetailForm.patchValue({
          materialName: this.customMaterialData,
        })
      : this.materialDetailForm.patchValue({
          materialName: this.packMaterialData.materialId,
        });

    this.conversionDetailForm.patchValue({
      country: this.conversionCountryData,
    });
    this.transportaionId = this.packMaterialData.transportaionId || 2;
    this.selectedBox = this.TransportationEnum.find((x: any, index: any) => {
      return this.transportaionId == this.TransportationEnum[index].id;
    });
    switch (this.selectedBox?.id) {
      case 2:
        this.wholeData[0]['img'] = this.loactionWhite;
        this.wholeData[1]['img'] = this.distanceBlack;
        this.wholeData[2]['img'] = this.customBlack;
        this.selectLocation = true;
        this.selectDistance = false;
        this.selectCustom = false;
        break;
      case 3:
        this.wholeData[0]['img'] = this.locationBlack;
        this.wholeData[1]['img'] = this.distanceWhite;
        this.wholeData[2]['img'] = this.customBlack;
        this.selectLocation = false;
        this.selectDistance = true;
        this.selectCustom = false;
        break;
      case 4:
        this.wholeData[0]['img'] = this.locationBlack;
        this.wholeData[1]['img'] = this.distanceBlack;
        this.wholeData[2]['img'] = this.customWhite;
        this.selectLocation = false;
        this.selectDistance = false;
        this.selectCustom = true;
        break;
      default:
        break;
    }
  }

  changeMaterialValue(data: any) {
    this.isCustomMaterial = data.target.checked ? true : false;
    if (!this.isCustomMaterial) {
      this.materialDetailForm.controls['materialRecycledContent'].setValidators([
        Validators.min(0),
        Validators.max(100),
      ]);
    } else {
      this.materialDetailForm.controls['materialRecycledContent'].clearValidators();
    }
    this.materialDetailForm.controls['materialRecycledContent'].updateValueAndValidity();
    this.materialDetailForm.controls['materialName'].setValue(null);
    this.materialDetailForm.controls['materialCost'].setValue(0);
  }
  onKeyDownEvent(event: any) {
    if (
      this.keywordAuto == undefined ||
      this.keywordAuto == null ||
      typeof this.keywordAuto == 'object'
    ) {
      this.keywordAuto = '';
    }
    onKeyDown(event, this.keywordAuto);
  }
  onSearch(searchValue: string) {
    if (this.keywordAuto == undefined || this.keywordAuto == null) {
      this.keywordAuto = '';
    }
    this.keywordAuto = this.keywordAuto?.trimStart();
    if (this.keywordAuto.length) {
      this.isLoading = true;
      this.pageNumber = 1;
      this.searchValue = this.keywordAuto;
      this.selectedCities = [];
      this.searchSubject.next(this.keywordAuto);
    }
  }

  onScroll() {
    if (this.selectedCities?.length < 50) return;
    this.pageNumber++;
    this.isLoading = true;
    this.searchCities(this.searchValue);
  }

  onChangeSearchSupplier(search: any) {
    this.searchSupplierList = [];
    this.isLoadingSupplier = true;
    this.searchSupplier(search);
  }

  onClearSearch(event: any) {
    this.isLoading = false;
    this.selectedCities = [];
    this.auto?.close();
    this.pageNumber = 1;
    this.searchValue = '';
    this.autoForOrigin?.close();
    this.autoForDestination?.close();
  }

  onClearSearchSupplier(event: any) {
    this.supplierId = null;
    this.selectedSupplier = null;
    this.isLoadingSupplier = false;
    this.searchSupplierList = [];
    event?.stopPropagation();
    this.auto.close();
  }

  async searchCities(searchValue: string) {
    const res: any = await this.sharedService.getAllFilterCity(
      this.pageNumber,
      searchValue,
      this.isShowPort
    );
    this.selectedCities = this.pageNumber === 1 ? res.data : [...this.selectedCities, ...res.data];
    this.autoForOrigin?.focus();
    this.autoForDestination?.focus();
    this.isLoading = false;
  }

  searchSupplier(search: string) {
    this.searchSupplierList = search
      ? this.supplier?.filter((item: any) =>
          item.name.toLowerCase().startsWith(search.toLowerCase())
        )
      : [];
    this.isLoadingSupplier = false;
    if (search == '' || !this.searchSupplierList.length) {
      this.supplierId = null;
      this.selectedSupplier = null;
    }
  }

  showPorts(event: any) {
    this.transportationDetailForm.controls['Origin'].setValue(null);
    this.transportationDetailForm.controls['destination'].setValue(null);
    this.isShowPort = event.target.checked;
  }

  areabasedConversion(event: any) {
    this.conversionProcessColumnDef.find((x: any) => x.headerName == 'Area').hide =
      !event.target.checked;
    this.isAreaBaseConversionProcess = event.target.checked ? true : false;
    if (!this.isAreaBaseConversionProcess) {
      this.isRecommendedConversionProcess = true;
    } else {
      this.isRecommendedConversionProcess = false;
    }
    this.isCustomConversion = false;
    this.conversionDetailForm.controls['conversion'].setValue(null);
  }

  chnageRecommendedConversion(event: any, conversionList: any) {
    this.conversionProcessColumnDef.find((x: any) => x.headerName == 'Area').hide =
      conversionList.filter((x: any) => x.areaBaseConversionProcess).length > 0
        ? !event.target.checked
        : true;
    this.isRecommendedConversionProcess = event.target.checked;
    if (!this.isRecommendedConversionProcess) {
      this.projectService.getAllOrganizationConversionProcess().subscribe((data: any) => {
        this.conversionNoSelectedProcessItems = data.data;
      });
    }
    this.isAreaBaseConversionProcess = false;
    this.isCustomConversion = false;
    this.conversionDetailForm.controls['conversion'].setValue(null);
  }

  selectedCertification(event: any) {
    Number(event.target.id) == 1
      ? (this.carbonNeutralValue = event.target.checked)
      : Number(event.target.id) == 2
      ? (this.fscCertificationValue = event.target.checked)
      : Number(event.target.id) == 3
      ? (this.otherCertificationValue = event.target.checked)
      : null;
  }

  changeCustyomConversion(event: any, conversionList: any) {
    this.conversionProcessColumnDef.find((x: any) => x.headerName == 'Area').hide =
      conversionList.filter((x: any) => x.areaBaseConversionProcess).length > 0
        ? !event.target.checked
        : event.target.checked;
    this.isCustomConversion = event.target.checked ? true : false;
    if (!this.isCustomConversion) {
      this.isRecommendedConversionProcess = true;
    } else {
      this.isRecommendedConversionProcess = false;
    }
    this.isAreaBaseConversionProcess = false;
    this.conversionDetailForm.controls['conversion'].setValue(null);
  }

  chnageCustomTruck(event: any, conversionList: any, dataList: any) {
    this.processColumnDef =
      this.projectPackMaterialListDataGridService.getTransportModalForManualLocationDataColumn();
    this.distanceProcessColumnDef =
      this.projectPackMaterialListDataGridService.getTransportModalForManualDestinationDataColumn();
    this.processColumnDef.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.distanceProcessColumnDef.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.conversionProcessColumnDef.find((x: any) => x.headerName == 'Area').hide =
      event.target.checked;
    this.isCustomTruck = event.target.checked ? true : false;
    this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
    this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
    this.percenteageMassLoad = 0;
  }
  addTransportDistance() {
    this.setManualDistanceSubmitted = true;
    if (
      this.transportationDetailForm.controls['transportModeForDistance'].value &&
      this.transportationDetailForm.controls['distance'].value
    ) {
      this.transportScenarioDataForDistance = {};
      this.transportScenarioDataForDistance['id'] = 0;
      this.transportScenarioDataForDistance['isCheckEditManudalDist'] = this.isCheckEditManudalDist;
      if (this.isCheckEditManudalDist) {
        this.transportScenarioDataForDistance['index'] =
          this.projectMaterialeditManualDistanceData.index;
      }
      this.transportScenarioDataForDistance['isCustomTruck'] = this.isCustomTruck;
      this.isCustomTruck
        ? (this.transportScenarioDataForDistance['customTruckId'] = !!this.transportModeId
            ? this.transportModeId
            : this.projectMaterialeditManualDistanceData.transportModeId)
        : (this.transportScenarioDataForDistance['transportModeId'] = !!this.transportModeId
            ? this.transportModeId
            : this.projectMaterialeditManualDistanceData.transportModeId);
      this.transportScenarioDataForDistance['transportModeName'] =
        this.transportationDetailForm.value.transportModeForDistance.name;
      this.transportScenarioDataForDistance['distance'] =
        this.transportationDetailForm.value.distance;
      this.transportScenarioDataForDistance['persanteageMassLoad'] = this.percenteageMassLoad || 0;
      this.projectFacde.transportScenarioActionsFordistance(
        this.transportScenarioDataForDistance,
        this.isCheckEditManudalDist ? 'edit' : 'add'
      );
      this.isCheckEditManudalDist = false;
      this.setManualDistanceSubmitted = false;
      this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
      this.transportationDetailForm.controls['distance'].setValue(null);
    }
  }

  setOrigin(dataList: any) {
    this.setOriginsubmitted = true;
    if (this.transportationDetailForm.controls['Origin']?.value?.hasOwnProperty('name')) {
      this.transportScenarioData = {
        id: 0,
        originName: this.transportationDetailForm.value.Origin.name,
        distance: '',
        originId: this.originId,
      };
      this.projectFacde.transportScenarioActions(
        this.transportScenarioData,
        this.isCheckUpdateOrigin ? 'edit' : 'add'
      );
      this.transportationDetailForm.controls['Origin'].reset();
      this.setOriginsubmitted = false;
      this.checkIsOrginBtn = false;
      this.isCheckUpdateOrigin = false;
    } else {
      return;
    }
  }

  toTitleCase(str: any) {
    return str.replace(/\w\S*/g, (txt: any) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
  getLastItem() {
    this.projectFacde.projectPackMaterialTransportScenarioList$
      .pipe(take(1))
      .subscribe((data: any) => {
        this.lastItem = this.isCheckUpdateDestination
          ? data[
              data.findIndex((item: any) => item.index === this.projectMaterialeditData.index) - 1
            ]
          : data[data?.length - 1];
      });
  }
  changeTransportMode(event: any) {
    if (!!event?.id) {
      this.transportModeId = event.id;
      this.transportModeName = event.name;
      this.transportModeDescription = event.description;
      this.getLastItem();
    }
    if (this.isCustomTruck && event?.id) {
      this.getMassLoad(event);
    }
  }

  changeTransportModeManudalDis(event: any) {
    if (!!event?.id) {
      this.transportModeId = event.id;
      this.transportModeName = event.name;
      this.transportModeDescription = event.description;
    }
    if (this.isCustomTruck && event.id) {
      this.getMassLoad(event);
    }
  }

  getMassLoad(event: any) {
    if (event.id) {
      this.projectService.getTruckMassLoad(event.id || event.truckId).subscribe((res: any) => {
        this.percenteageMassLoad = res.data.percenteageMassLoad;
      });
    }
  }

  seaDistanceMatrix(lastItem: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const fromCity = lastItem.originName;
      const toCity = this.transportationDetailForm.controls['destination'].value?.name;
      const bothCity: string[] = [fromCity, toCity];
      const geocoder = new google.maps.Geocoder();
      // Use map to create an array of observables for geocoding requests
      const geocodeRequests = bothCity.map((address: string) => {
        return new Observable(observer => {
          geocoder.geocode({ address: address }, (results, status) => {
            if (status === 'OK') {
              const location = results![0].geometry.location;
              observer.next({ latitude: location.lat(), longitude: location.lng() });
              observer.complete();
            } else {
              observer.error(`Geocode was not successful for ${address} due to: ` + status);
            }
          });
        });
      });

      // Wait for all geocoding requests to complete
      forkJoin(geocodeRequests).subscribe(
        async (results: any[]) => {
          const [fromLocation, toLocation] = results;
          const latFrom = fromLocation.latitude;
          const lngFrom = fromLocation.longitude;
          const latTo = toLocation.latitude;
          const lngTo = toLocation.longitude;

          // Now you can make the API call
          const distanceType = this.sharedService.getDistanceTypeByTransportMode(
            this.transportModeId
          );
          const res = await this.sharedService.getDistanceAndTime(
            latFrom,
            lngFrom,
            latTo,
            lngTo,
            lastItem.originId,
            this.transportationDetailForm.controls['destination'].value?.idStr,
            distanceType
          );
          if (
            this.transportModeId == commonEnum.AIR_INTERNATIONAL ||
            this.transportModeId == commonEnum.AIR_DOMESTIC
          ) {
            this.transportationDetailForm.controls['distance'].setValue(
              formatNumber(res.data) + ' ' + 'km'
            );
            this.setManualLocationDis = formatNumber(res.data) + ' ' + 'km';
          } else if (this.transportModeId == commonEnum.SHIP_INTERNATIONAL) {
            this.seaDistance = formatNumber(res.data) + ' ' + 'km';
          }
          resolve(); // Resolve the promise once everything is done
        },
        error => {
          console.error(error);
          reject(error); // Reject the promise in case of an error
        }
      );
    });
  }

  async calculateDistance(lastItem: any) {
    const payload = {
      origin: lastItem.originName,
      destination: this.transportationDetailForm.controls['destination'].value?.name,
      destinationId: Number(this.transportationDetailForm.controls['destination'].value?.idStr),
      iscustomtruck: this.isCustomTruck,
      transportmodeId: this.transportModeId,
      customTransoportScenarioDetails: [
        {
          id: 0,
          cityId: lastItem.originId,
          cityName: lastItem.originName,
          transportModeName: this.transportModeName,
          customTransportScenarioId: 0,
          imageName: lastItem.description,
        },
      ],
    };
    const response: any = await this.customService.getSeaDistanceForTransportAsync(payload);
    if (
      (response.data.distance >= 0 && response.data.isShip) ||
      response?.message.includes('must be a valid Port')
    ) {
      this.transportationDetailForm.controls['distance'].setValue(response?.data.distance);
      const setManualLocationDis = response?.data.distance;
      this.setManualLocationDis = setManualLocationDis;
      this.isValidPort = response.message;
      this.messageType = response.messageType;
      return response;
    } else {
      await this.getCalculateDis();
    }
  }

  async getCalculateDis() {
    await this.mapsAPILoader.load();
    const service = new google.maps.DistanceMatrixService();
    const request: any = {
      origins: [this.lastItem.originName],
      destinations: [this.transportationDetailForm.controls['destination'].value.name],
      travelMode: 'DRIVING',
    };
    return new Promise((resolve, reject) => {
      service.getDistanceMatrix(request, (response: any, status: any) => {
        if (status === 'OK') {
          const distance = !!response.rows[0].elements[0].distance?.text
            ? response.rows[0].elements[0].distance?.text
            : '0 km';
          this.transportationDetailForm.controls['distance'].setValue(distance);
          this.setManualLocationDis = distance;
          resolve(distance);
        } else {
          reject(new Error(`Distance calculation failed with status: ${status}`));
        }
      });
    });
  }
  async getCalculateDisForNextRecord(lastItem: any, nextItem: any) {
    await this.mapsAPILoader.load();
    const service = new google.maps.DistanceMatrixService();
    const request: any = {
      origins: [lastItem],
      destinations: [nextItem.originName],
      travelMode: 'DRIVING',
    };
    return new Promise((resolve, reject) => {
      service.getDistanceMatrix(request, (response: any, status: any) => {
        if (status === 'OK') {
          const distance = !!response.rows[0].elements[0].distance?.text
            ? response.rows[0].elements[0].distance?.text
            : '0 km';
          this.setManualLocationDisForNextRecord = distance;
          resolve(distance);
        } else {
          reject(new Error(`Distance calculation failed with status: ${status}`));
        }
      });
    });
  }

  async seaDistanceMatrixNextRecord(
    lastItem: any,
    nextItem: any,
    originId: any,
    destinationId: any
  ): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const fromCity = lastItem;
      const toCity = nextItem.originName;
      const bothCity: string[] = [fromCity, toCity];
      const geocoder = new google.maps.Geocoder();

      // Use map to create an array of observables for geocoding requests
      const geocodeRequests = bothCity.map((address: string) => {
        return new Observable(observer => {
          geocoder.geocode({ address: address }, (results, status) => {
            if (status === 'OK') {
              const location = results![0].geometry.location;
              observer.next({ latitude: location.lat(), longitude: location.lng() });
              observer.complete();
            } else {
              observer.error(`Geocode was not successful for ${address} due to: ` + status);
            }
          });
        });
      });

      // Wait for all geocoding requests to complete
      forkJoin(geocodeRequests).subscribe(
        async (results: any[]) => {
          const [fromLocation, toLocation] = results;
          const latFrom = fromLocation.latitude;
          const lngFrom = fromLocation.longitude;
          const latTo = toLocation.latitude;
          const lngTo = toLocation.longitude;

          // Now you can make the API call
          const distanceType = this.sharedService.getDistanceTypeByTransportMode(
            this.transportModeId
          );
          const res = await this.sharedService.getDistanceAndTime(
            latFrom,
            lngFrom,
            latTo,
            lngTo,
            originId,
            destinationId,
            distanceType
          );
          if (
            this.transportModeId == commonEnum.AIR_INTERNATIONAL ||
            this.transportModeId == commonEnum.AIR_DOMESTIC
          ) {
            this.setManualLocationDisForNextRecord = formatNumber(res.data) + ' ' + 'km';
          } else if (this.transportModeId == commonEnum.SHIP_INTERNATIONAL) {
            this.setManualLocationDisForNextRecord = formatNumber(res.data) + ' ' + 'km';
          }
          resolve(); // Resolve the promise once everything is done
        },
        error => {
          console.error(error);
          reject(error); // Reject the promise in case of an error
        }
      );
    });
  }

  refreshMaterialCertificateNames() {
    this.myOrganizationService
      .getOrganizationCertificationData()
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        )
      )
      .subscribe(res => {
        this.certificateData = res.data;
      });
  }

  changeNextRecordDistance() {
    this.projectFacde.projectPackMaterialTransportScenarioList$
      .pipe(take(1))
      .subscribe(async (data: any) => {
        const startIndex = data.findIndex(
          (item: any) => item.index === this.projectMaterialeditData.index
        ); // Index to start checking after
        if (this.isCheckUpdateDestination && startIndex < data.length - 1) {
          let destinationNextRecord =
            data[
              data.findIndex((item: any) => item.index === this.projectMaterialeditData.index) + 1
            ];
          const lastItemNextRecord = this.transportationDetailForm.value.destination;
          try {
            if (
              destinationNextRecord.transportModeName == commonEnum.shipName ||
              destinationNextRecord.transportModeName?.toLowerCase() == commonEnum.airName ||
              destinationNextRecord.transportModeName?.toLowerCase() == commonEnum.airDomesticName
            ) {
              var originId = lastItemNextRecord?.originId;
              var destinationId = destinationNextRecord?.idStr;
              await this.seaDistanceMatrixNextRecord(
                lastItemNextRecord.name,
                destinationNextRecord,
                originId,
                destinationId
              );
            } else {
              await this.getCalculateDisForNextRecord(
                lastItemNextRecord.name,
                destinationNextRecord
              );
            }
            Object.freeze(destinationNextRecord);
            const objCopy = { ...destinationNextRecord };
            objCopy.distance = this.setManualLocationDisForNextRecord;
            destinationNextRecord = objCopy;
            this.projectFacde.transportScenarioActions(destinationNextRecord, 'edit');
          } catch (error) {
            // Handle error, e.g., log it or show a user-friendly message.
            console.error('Error:', error);
          }
        }
      });
  }

  deleteSetDistanceRecord(allRecorsds: any, deleteRecord: any) {
    this.projectFacde.projectPackMaterialTransportScenarioList$
      .pipe(take(1))
      .subscribe(async (allManualLocationData: any) => {
        const indexToDelete = allRecorsds.findIndex(
          (record: any) => record.index === deleteRecord.index
        );
        if (indexToDelete !== -1) {
          // Delete the record
          // Create a new array excluding the deleted record
          const newArray = allRecorsds.filter((record: any, index: any) => index !== indexToDelete);
          const aboveRecord = newArray[indexToDelete - 1];
          let belowRecord = newArray[indexToDelete];
          // newArray now contains the array with the specified record deleted
          if (!!belowRecord) {
            if (
              belowRecord.transportModeName == commonEnum.shipName ||
              belowRecord.transportModeName?.toLowerCase() == commonEnum.airName ||
              belowRecord.transportModeName?.toLowerCase() == commonEnum.airDomesticName
            ) {
              var originId = aboveRecord?.originId;
              var destinationId = belowRecord?.idStr;
              await this.seaDistanceMatrixNextRecord(
                aboveRecord.originName,
                belowRecord,
                originId,
                destinationId
              );
            } else {
              await this.getCalculateDisForNextRecord(aboveRecord.originName, belowRecord);
            }
            Object.freeze(belowRecord);
            const objCopy = { ...belowRecord };
            objCopy.distance = this.setManualLocationDisForNextRecord;
            objCopy.index = allManualLocationData[indexToDelete].index;
            belowRecord = objCopy;
            this.projectFacde.transportScenarioActions(belowRecord, 'edit');
          }
        }
      });
  }

  async setDestination() {
    this.setDestinationsubmitted = true;
    if (
      this.transportationDetailForm.controls['destination']?.value?.hasOwnProperty('name') &&
      this.transportationDetailForm.controls['transportModeForLocation'].value &&
      !this.isCustomTruck
    ) {
      this.setDestinationsubmitted = false;
      if (
        this.isCheckUpdateDestination &&
        this.transportationDetailForm.controls['distanceManulaLocation'].value == 0
      ) {
        return;
      }
      if (
        (this.transportationDetailForm.controls['destination']?.value?.name?.includes('Port') &&
          (this.lastItem?.originName?.includes('Port') || this.lastItem?.name?.includes('Port')) &&
          this.transportModeName?.toLowerCase() == commonEnum.shipName) ||
        this.transportModeName?.toLowerCase() == commonEnum.airName ||
        this.transportModeName?.toLowerCase() == commonEnum.airDomesticName
      ) {
        await this.seaDistanceMatrix(this.lastItem);
      } else {
        !!this.transportModeId && (await this.calculateDistance(this.lastItem));
      }
      if (this.messageType != 1) {
        this.messageType = 0;
        if (
          (this.transportationDetailForm.controls['destination']?.value?.idStr ||
            this.transportationDetailForm.controls['destination']?.value?.originId) ==
            this.projectMaterialeditData?.originId &&
          this.transportModeId == this.projectMaterialeditData?.transportModeId
        ) {
          this.setApiResDistance = true;
        }
        !!this.projectMaterialeditData?.originId &&
          this.transportationDetailForm.controls['destination']?.value?.idStr !=
            this.projectMaterialeditData?.originId &&
          this.changeNextRecordDistance();
        this.destinationData = {};
        this.destinationData['id'] = 0;
        if (this.isCheckUpdateDestination) {
          this.destinationData['index'] = this.projectMaterialeditData?.index;
        }
        this.destinationData['isCustomTruck'] = this.isCustomTruck;
        this.isCustomTruck
          ? (this.destinationData['customTruckId'] = !!this.transportModeId
              ? this.transportModeId
              : this.projectMaterialeditData.transportModeId)
          : (this.destinationData['transportModeId'] = !!this.transportModeId
              ? this.transportModeId
              : this.projectMaterialeditData.transportModeId);
        this.destinationData['transportModeName'] =
          this.transportationDetailForm.value.transportModeForLocation.name;
        this.destinationData['persanteageMassLoad'] = this.percenteageMassLoad || 0;
        const newManualLocationDisatance =
          this.transportationDetailForm.controls['distanceManulaLocation'].value;
        const getDisType =
          typeof this.projectMaterialeditData?.distance == 'string' &&
          !!this.projectMaterialeditData?.distance
            ? this.projectMaterialeditData?.distance?.substring(
                this.projectMaterialeditData.distance.indexOf(' ') + 1
              )
            : 'km';
        const newVal = newManualLocationDisatance + ' ' + (getDisType == '0' ? ' ' : getDisType);
        if (this.transportModeName?.toLowerCase() == commonEnum.shipName) {
          this.destinationData['distance'] =
            this.isCheckUpdateDestination && this.setApiResDistance ? newVal : this.seaDistance;
        } else {
          this.destinationData['distance'] =
            this.isCheckUpdateDestination && this.setApiResDistance
              ? newVal
              : this.setManualLocationDis;
        }
        this.destinationData['originId'] =
          this.transportationDetailForm.value.destination.idStr ||
          this.transportationDetailForm.value.destination.originId;
        this.destinationData['idStr'] = this.destinationData['originId'];
        this.destinationData['originName'] = this.transportationDetailForm.value.destination.name;
        this.destinationData['isOrigin'] = this.isCheckUpdateDestination
          ? this.projectMaterialeditData.isOrigin
          : true;
        this.setDestinationsubmitted = false;
        this.transportationDetailForm.controls['destination'].reset();
        this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
        this.projectFacde.transportScenarioActions(
          this.destinationData,
          this.isCheckUpdateDestination ? 'edit' : 'add'
        );
        this.setOriginsubmitted = false;
        this.isCheckUpdateDestination = false;
        this.setApiResDistance = false;
        this.isValidPort = '';
      } else if (this.messageType == 1) {
        this.setDestinationsubmitted = false;
        this.transportationDetailForm.controls['transportModeForLocation'].reset();
        this.messageType = 0;
      }
    } else if (
      this.transportationDetailForm.controls['destination'].status == 'VALID' &&
      this.transportationDetailForm.controls['transportModeForLocation'].value &&
      this.isCustomTruck
    ) {
      if (
        this.isCheckUpdateDestination &&
        this.transportationDetailForm.controls['distanceManulaLocation'].value == 0
      ) {
        return;
      }
      this.messageType = 0;
      this.destinationData = {};
      this.destinationData['id'] = 0;
      if (this.isCheckUpdateDestination) {
        this.destinationData['index'] = this.projectMaterialeditData?.index;
      }
      await this.calculateDistance(this.lastItem);
      this.destinationData['isCustomTruck'] = this.isCustomTruck;
      this.isCustomTruck
        ? (this.destinationData['customTruckId'] = this.transportModeId)
        : (this.destinationData['transportModeId'] = this.transportModeId);
      this.destinationData['transportModeName'] =
        this.transportationDetailForm.value.transportModeForLocation.name;
      this.destinationData['persanteageMassLoad'] = this.percenteageMassLoad || 0;
      const newManualLocationDisatance =
        this.transportationDetailForm.controls['distanceManulaLocation'].value;
      const getDisType =
        typeof this.projectMaterialeditData?.distance == 'string' &&
        !!this.projectMaterialeditData?.distance
          ? this.projectMaterialeditData?.distance?.substring(
              this.projectMaterialeditData.distance.indexOf(' ') + 1
            )
          : 'km';
      const newVal = newManualLocationDisatance + ' ' + (getDisType == '0' ? ' ' : getDisType);
      this.destinationData['distance'] = this.isCheckUpdateDestination
        ? newVal
        : this.setManualLocationDis;
      this.destinationData['originId'] =
        this.transportationDetailForm.value.destination?.idStr ||
        this.transportationDetailForm.value.destination?.originId;
      this.destinationData['originName'] = this.transportationDetailForm.value.destination.name;
      this.destinationData['isOrigin'] = this.isCheckUpdateDestination
        ? this.projectMaterialeditData.isOrigin
        : true;
      this.setDestinationsubmitted = false;
      this.transportationDetailForm.controls['destination'].reset();
      this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
      this.projectFacde.transportScenarioActions(
        this.destinationData,
        this.isCheckUpdateDestination ? 'edit' : 'add'
      );
      this.setOriginsubmitted = false;
      this.isCheckUpdateDestination = false;
    }
  }

  addConversion(getConversionList: any) {
    this.addConversionSubmitted = true;
    if (
      this.conversionDetailForm.controls['conversion'].value &&
      this.conversionDetailForm.controls['country'].value
    ) {
      this.conversionProcessColumnDef = cloneDeep(this.conversionProcessColumnDef);
      this.conversionProcessColumnDef.find(
        (x: any) => x.headerName == 'Country'
      ).cellRendererParams['conversionRegion'] = this.conversionRegion;
      this.conversionProcessColumnDef.find(
        (x: any) => x.headerName == 'Converter'
      ).cellRendererParams['supplier'] = this.supplier;

      this.conversionData = {};

      const converterValue = this.conversionDetailForm.value.converter;
      let converterId = null;
      let converterName = null;

      if (converterValue) {
        if (typeof converterValue === 'string') {
          converterName = converterValue;
        } else if (converterValue.name) {
          converterName = converterValue.name;
          converterId = converterValue.id ?? null;
        }
      }

      this.conversionData['id'] = 0;
      this.conversionData['conversionProcessName'] =
        this.conversionDetailForm.value.conversion.description ??
        this.conversionDetailForm.value.conversion.name;
      this.conversionData['conversionCountryId'] = this.conversionDetailForm.value.country.id;
      this.conversionData['areaBaseConversionProcess'] = this.conversionDetailForm.value.area ?? '';
      this.conversionData['conversionSupplierId'] = converterId;
      this.conversionData['conversionSupplierName'] = converterName;
      this.conversionData['conversionCost'] =
        this.conversionDetailForm.controls['conversionCost'].value;
      this.conversionData['isRecommendedConversionProcess'] = this.isRecommendedConversionProcess;
      this.conversionData['isAreaBaseConversionProcess'] = this.isAreaBaseConversionProcess;
      this.conversionData['isCustomConversion'] = this.isCustomConversion;

      if (this.isAreaBaseConversionProcess) {
        this.conversionData['areaConversionId'] = this.conversionDetailForm.value.conversion.id;
      } else if (this.isRecommendedConversionProcess) {
        this.conversionData['conversionProcessId'] = this.conversionDetailForm.value.conversion.id;
      } else if (this.isCustomConversion) {
        this.conversionData['customConversionId'] =
          this.conversionDetailForm.value.conversion.idStr;
      } else {
        this.conversionData['conversionProcessId'] = this.conversionDetailForm.value.conversion.id;
      }

      this.projectFacde.packMaterialConversionProcess(this.conversionData, 'add');
      this.conversionDetailForm.controls['converter'].setValue(null);
      this.conversionDetailForm.controls['conversion'].setValue(null);
      this.conversionDetailForm.controls['conversionCost'].setValue(null);
    }
    this.conversionDetailForm.controls['area'].setValue('');
  }

  changeCustomTransportItem(event: any) {
    this.customTransportList = [];
    this.isShowCustomTransportList = false;
    if (!!event?.id) {
      this.customFreightSelectData = event;
    }
  }

  resetTransport() {
    this.customFreightSelectData = null;
  }
  addCustomFreight() {
    if (!!this.customFreightSelectData) {
      this.checkAddCustomFreight = true;
      this.CustomtransportScenarioId = this.customFreightSelectData.id;
      if (this.customFreightSelectData.isCustomSiteTransport) {
        this.projectService
          .GetCustomSiteTransportList(this.CustomtransportScenarioId)
          .subscribe((data: any) => {
            this.customTransportDef =
              this.projectPackMaterialListDataGridService.getCustomTransportItemsList();
            this.isShowCustomTransportList = true;
            this.customTransportList = data;
          });
      } else {
        this.projectService
          .GetCustomTransportList(this.CustomtransportScenarioId)
          .subscribe((data: any) => {
            this.customTransportDef =
              this.projectPackMaterialListDataGridService.getCustomTransportItemsList();
            this.isShowCustomTransportList = true;
            this.customTransportList = data;
          });
      }
    }
  }

  selectEvent(event: any) {
    this.originId = event.idStr;
    this.pageNumber = 1;
    this.searchValue = '';
    this.keywordAuto = '';
    this.selectedCities = [];
  }

  selectedMaterial(event: any) {
    if (!event.id) return;
    this.supplierId = event.id;
    this.selectedSupplier = event.id;
  }

  onClose() {
    this.projectFacde.clearTransportScenario();
    this.modal.close();
  }
  manualLocation(data: any) {
    this.selectLocation = false;
    this.selectDistance = false;
    this.selectCustom = false;
    this.isCheckEditManudalDist = false;
    this.isCheckUpdateOrigin = false;
    this.isCheckUpdateDestination = false;
    this.isCustomTruck = false;
    this.processColumnDef =
      this.projectPackMaterialListDataGridService.getTransportModalForManualLocationDataColumn();
    this.distanceProcessColumnDef =
      this.projectPackMaterialListDataGridService.getTransportModalForManualDestinationDataColumn();
    this.processColumnDef.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.distanceProcessColumnDef.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.wholeData[0]['img'] = this.locationBlack;
    this.wholeData[1]['img'] = this.distanceBlack;
    this.wholeData[2]['img'] = this.customBlack;
    switch (data.type) {
      case 'location':
        this.wholeData[0]['img'] = this.loactionWhite;
        this.selectedBox.id = 2;
        this.selectLocation = true;
        this.isShowCustomTransportList = false;
        this.transportaionId = 2;
        this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
        this.transportationDetailForm.controls['distance'].setValue(null);
        this.customTransportList = null;
        this.percenteageMassLoad = 0;
        this.projectFacde.clearFreightProcess();
        // Set all location grid data's enableEdit flag to false
        this.projectFacde.projectPackMaterialTransportScenarioList$
          .pipe(take(1))
          .subscribe((data: any) => {
            if (data && data.length > 0) {
              const updatedData = data.map((item: any) => ({
                ...item,
                enableEditing: false,
              }));
              this.projectFacde.transportScenarioActions(updatedData, 'reset');
            }
          });
        break;
      case 'distance':
        this.wholeData[1]['img'] = this.distanceWhite;
        this.selectedBox.id = 3;
        this.selectDistance = true;
        this.isShowDistantField = false;
        this.isShowCustomTransportList = false;
        this.transportaionId = 3;
        this.customTransportList = null;
        this.transportationDetailForm.controls['destination'].setValue(null);
        this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
        this.transportationDetailForm.controls['distanceManulaLocation'].setValue('');
        this.transportationDetailForm.controls['Origin'].setValue('');
        this.projectFacde.clearFreightProcess();
        this.percenteageMassLoad = 0;
        this.projectFacde.getTransportScenarioListFordistance$
          .pipe(take(1))
          .subscribe((data: any) => {
            if (data && data.length > 0) {
              const updatedData = data.map((item: any) => ({
                ...item,
                enableEditing: false,
              }));
              this.projectFacde.transportScenarioActionsFordistance(updatedData, 'reset');
            }
          });
        break;
      case 'custom':
        this.wholeData[2]['img'] = this.customWhite;
        this.selectedBox.id = 4;
        this.selectCustom = true;
        this.checkAddCustomFreight = false;
        this.isShowDistantField = false;
        this.transportaionId = 4;
        this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
        this.transportationDetailForm.controls['distance'].setValue(null);
        this.transportationDetailForm.controls['destination'].setValue(null);
        this.transportationDetailForm.controls['distanceManulaLocation'].setValue('');
        this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
        this.transportationDetailForm.controls['transportModeForDistance'].clearValidators();
        this.transportationDetailForm.controls['distance'].clearValidators();
        this.percenteageMassLoad = 0;
        this.addCustomFreight();
        break;
      default:
        break;
    }
  }

  getCustomMaterialList() {
    this.projectService.getCustomMaterialList().subscribe((data: any) => {
      this.customMaterialItems = data.data;
    });
  }

  getCustomConversionProcessList() {
    this.projectService.getCustomConversionProcessList().subscribe((data: any) => {
      this.customConversionItems = data.data;
    });
  }

  getCustomTruckList() {
    this.projectService.getCustomTruckList().subscribe((data: any) => {
      this.customTruckItems = data.data;
    });
  }

  getCustomTransport() {
    this.customService.getAllCustomTransportList().subscribe((res: any) => {
      this.customtransportScenarioItems = res.data;
    });
  }

  noSpecialKeys(event: any) {
    const allowedKeys = /^[0-9.]$/; // RegEx to allow digits and one decimal point

    if (
      event.key === 'Backspace' ||
      event.key === 'Delete' ||
      event.key === 'ArrowUp' ||
      event.key === 'ArrowRight' ||
      event.key === 'ArrowDown' ||
      event.key === 'ArrowLeft'
    )
      return;

    if (!allowedKeys.test(event.key)) {
      event.preventDefault();
    }

    // logic to allow only one decimal point
    const input = event.target.value;
    const hasDecimalPoint = input.includes('.');

    if (event.key === '.' && hasDecimalPoint) {
      event.preventDefault();
    }
  }

  async getMaterialValue(data: any) {
    if (this.isCustomMaterial) {
      return;
    }
    if (!!data.id) {
      await this.getConversionProcess(data);
      this.conversionDetailForm.controls['conversion'].setValue(null);
      await this.getMaterialAndRecycledCost(data);
      this.materialInfo();
    }
  }
  getMaterialRegion(data: any) {
    this.materialInfo();
  }

  async getConversionProcess(data: any, flag?: boolean) {
    const res = await this.projectService.getConversionProcess(data.id, true);
    this.conversionProcessItems = res.data;
    if (!res.data?.length) {
      this.isRecommendedConversionProcess = false;
      this.projectService.getAllOrganizationConversionProcess().subscribe((data: any) => {
        this.conversionNoSelectedProcessItems = data.data;
      });
      !flag &&
        this.toaster.warning('No recommended conversion process was found for this material');
    } else {
      this.isRecommendedConversionProcess = true;
      this.conversionProcessItems = res.data;
    }
  }

  async getMaterialAndRecycledCost(data: any) {
    const res: any = await this.projectService.getRecycledContentData(
      data.id,
      this.materialCountryData?.id
    );
    this.noRecycledContents = res?.data.noRecycledContents;
    this.isDisableRecycledContent = res?.data.isDisableRecycledContent;
    const value = this.decimalFormatPipePipe.transform(Number(res?.data?.recycleContent));
    !this.noRecycledContents &&
      this.materialDetailForm.controls['materialRecycledContent'].setValue(value);
    this.materialDetailForm.controls['materialCost'].setValue(res?.data?.cost);
  }

  materialInfo() {
    const materialId = !this.isCustomMaterial ? this.materialDetailForm.value.materialName : 0;
    const customMaterialId = this.isCustomMaterial
      ? this.materialDetailForm.value.materialName?.id
      : 0;
    const countryId = this.materialDetailForm.value.materialCountry?.id || 0;
    const regionId = 0;
    this.projectService
      .packMaterialInfo(materialId, countryId, customMaterialId, regionId)
      .subscribe((data: any) => {
        this.materialInfoData = data.data;
        this.materialInfoDataKey = Object.keys(this.materialInfoData);
        this.materialInfoDataValues = Object.values(this.materialInfoData);
        this.materialname = this.materialInfoData.name;
        if (!this.isCustomMaterial) {
          if (!this.noRecycledContents) {
            this.showRecycledContent = true;
            this.materialDetailForm.controls['materialRecycledContent'].setValidators([
              Validators.min(0),
              Validators.max(100),
            ]);
          } else {
            this.toaster.warning("Warning : This material can't have any recycled content in it.");
            this.showRecycledContent = false;
            this.materialDetailForm.controls['materialRecycledContent'].clearValidators();
            this.materialDetailForm.controls['materialRecycledContent'].reset();
          }
        }
        this.materialDetailForm.controls['materialRecycledContent'].updateValueAndValidity();
      });
  }
  editConversionProcess(record: any) {}
  saveData(
    conversionItem: any,
    getTransportScenarioListFordistance: any,
    projectPackMaterialTransportScenarioList: any
  ) {
    if (this.selectLocation) {
      projectPackMaterialTransportScenarioList = projectPackMaterialTransportScenarioList;
      getTransportScenarioListFordistance = [];
      this.CustomtransportScenarioId = undefined;
    } else if (this.selectDistance) {
      getTransportScenarioListFordistance = getTransportScenarioListFordistance;
      projectPackMaterialTransportScenarioList = [];
      this.CustomtransportScenarioId = undefined;
    } else {
      projectPackMaterialTransportScenarioList = [];
      getTransportScenarioListFordistance = [];
    }
    if (!!projectPackMaterialTransportScenarioList) {
      projectPackMaterialTransportScenarioList = projectPackMaterialTransportScenarioList.map(
        (item: any) => {
          if (typeof item.distance === 'string' && item.distance != 0) {
            const type = item.distance?.substring(item.distance.indexOf(' ') + 1);
            Object.freeze(item);
            const objCopy = { ...item };
            const distanceWithoutCommas = item.distance.replace(/,/g, '');
            objCopy.distance = parseFloat(distanceWithoutCommas);
            objCopy.unit = type;
            item = objCopy;
          } else {
            Object.freeze(item);
            const objCopy = { ...item };
            objCopy.unit = 'km';
            item = objCopy;
          }
          return item;
        }
      );
    }

    if (!!getTransportScenarioListFordistance) {
      getTransportScenarioListFordistance = getTransportScenarioListFordistance.map((item: any) => {
        return {
          ...item,
          unit: 'km',
        };
      });
    }

    this.submittedForComponent = true;
    this.submittedForMaterial = true;
    if (this.projectPackMaterialForm.valid) {
      const mainPayload: any = {};
      mainPayload['name'] =
        this.componentDetailForm.value.componentName.charAt(0).toUpperCase() +
        this.componentDetailForm.value.componentName.slice(1);
      mainPayload['scenarioId'] = this.scenarioId;
      mainPayload['packageLevelId'] =
        this.componentDetailForm.value.packagingLevels?.packageLevelInfoId;
      mainPayload['recylcableComponent'] = this.materialDetailForm.value.recyclableComponent?.id;
      mainPayload['materialSupplierId'] = this.supplierId
        ? this.supplierId
        : !this.projectPackMaterialForm?.get('componentDetailForm')?.get('Supplier')?.value
        ? null
        : 0;
      mainPayload['materialSupplierName'] = !this.selectedSupplier
        ? this.projectPackMaterialForm?.get('componentDetailForm')?.get('Supplier')?.value
        : null;
      mainPayload['isCustomMaterial'] = this.isCustomMaterial;
      mainPayload['transportaionId'] = this.transportaionId;
      mainPayload['materialCountryId'] = this.materialDetailForm.value.materialCountry?.id;
      mainPayload['materialWeight'] = this.materialDetailForm.value.materialWeigth;
      mainPayload['recycledContent'] = this.materialDetailForm.value.materialRecycledContent;
      mainPayload['materialCost'] = this.materialDetailForm.value.materialCost;
      mainPayload['conversionCountryId'] = this.conversionDetailForm.value.country?.id;
      mainPayload['conversionSupplierId'] = this.conversionDetailForm.value.converter?.id || null;
      mainPayload['conversionProcessItems'] = conversionItem;
      mainPayload['distanceTransportationItems'] = getTransportScenarioListFordistance;
      mainPayload['CustomtransportScenarioId'] = this.checkAddCustomFreight
        ? this.CustomtransportScenarioId
        : undefined;
      mainPayload['locationTransportationItems'] = projectPackMaterialTransportScenarioList;
      mainPayload['isRecommendedConversionProcess'] = this.isRecommendedConversionProcess;
      mainPayload['isAreaBaseConversionProcess'] = this.isAreaBaseConversionProcess;
      mainPayload['isCustomConversion'] = this.isCustomConversion;
      mainPayload['componentId'] = this.isBookmarked ? 0 : this.packMaterialData.componentId || 0;
      mainPayload['carbonNeutral'] = this.carbonNeutralValue;
      mainPayload['fscCertification'] = this.fscCertificationValue;
      mainPayload['otherCertification'] = this.otherCertificationValue;
      this.isCustomMaterial
        ? (mainPayload['customMaterialId'] = this.materialDetailForm.value.materialName?.id)
        : (mainPayload['materialId'] = this.materialDetailForm.value.materialName);

      mainPayload['componentDataSourceId'] = this.componentDataSourceId
        ? this.componentDataSourceId
        : !this.projectPackMaterialForm?.get('componentDetailForm')?.get('componentDataSource')
            ?.value
        ? null
        : 0;
      mainPayload['componentDataSourceName'] = !this.selectedComponentDataSource
        ? this.projectPackMaterialForm?.get('componentDetailForm')?.get('componentDataSource')
            ?.value
        : null;

      const missingFeatures = this.validateMaterialFeatures(mainPayload);

      if (missingFeatures.length > 0) {
        showFeatureAlert(missingFeatures, this.swalService);
        return;
      }
      this.saveNewMyProjectPackMaterialEvent.emit(mainPayload);
      this.modal.close();
      this.checkAddCustomFreight = false;
      this.projectFacde.clearTransportScenario();
    }
  }

  closePopup(step: string) {
    switch (step) {
      case 'one':
        this.popoverOne.close();
        this.popoverTwo.open();
        break;
      case 'two':
        this.popoverTwo.close();
        this.popoverThree.open();
        break;
      case 'three':
        this.popoverThree.close();
        this.popoverFour.open();
        scrollToSpecific('mat-cert');
        break;
      case 'four':
        this.popoverFour.close();
        this.popoverFive.open();
        break;
      case 'five':
        this.popoverFive.close();
        scrollToSpecific('org-top');
        this.sharedService.updateGuideTourStatus(GuideTourEnum.ComponentTour, true).subscribe();
        break;
    }
  }

  goBack(step: string) {
    switch (step) {
      case 'two':
        this.popoverTwo.close();
        this.popoverOne.open();
        break;
      case 'three':
        this.popoverThree.close();
        this.popoverTwo.open();
        scrollToSpecific('org-top');
        break;
      case 'four':
        this.popoverFour.close();
        this.popoverThree.open();
        break;
      case 'five':
        this.popoverFive.close();
        this.popoverFour.open();
        break;
    }
  }

  closeAllSteps(stepNum: any) {
    this.popoverOne.close();
    this.popoverTwo.close();
    this.popoverThree.close();
    this.popoverFour.close();
    this.popoverFive.close();
    this.sharedService
      .updateGuideTourStatus(GuideTourEnum.ComponentTour, false, stepNum)
      .subscribe();
  }

  triggerPopup() {
    setTimeout(() => {
      this.popoverOne.open();
    }, 0);
  }

  checkedBookMark(eve: any) {
    this.isBookmarked = eve.target.checked;
  }

  selectBookMark(event: any) {
    if (event.componentId) {
      this.projectService
        .getAddEditPackMaterialModal(this.scenarioId, event.componentId, true)
        .subscribe((data: any) => {
          if (!data.messageType) {
            data.data.conversionProcessItems = data.data.conversionProcessItems.map((item: any) => {
              return {
                ...item,
                index: item.id,
              };
            });
            data.data.distanceTransportationItems = data.data.distanceTransportationItems.map(
              (item: any) => {
                return {
                  ...item,
                  index: item.id,
                };
              }
            );
            data.data.locationTransportationItems = data.data.locationTransportationItems.map(
              (item: any) => {
                item.distance = this.setUnit(item);
                return {
                  ...item,
                  index: item.id,
                  distance: item.isOrigin ? '' : item.distance,
                };
              }
            );
            this.packMaterialData = data.data;
            this.customTransportDef =
              this.projectPackMaterialListDataGridService.getCustomTransportItemsList();
            this.projectPackMaterialForm = this.formBuilder.group({
              componentDetailForm: this.formBuilder.group({
                componentName: [
                  this.packMaterialData.name || null,
                  [Validators.required, noWhitespaceValidator],
                ],
                packagingLevels: [null, Validators.required],
                Supplier: [this.packMaterialData.materialSupplierName || null],
                componentDataSource: [this.packMaterialData?.componentDataSourceName || null],
              }),
              materialDetailForm: this.formBuilder.group({
                materialName: [null, Validators.required],
                materialCountry: [null],
                materialCost: [this.materialCost || 0.0],
                materialWeigth: [this.packMaterialData.materialWeight || '', Validators.required],
                materialRecycledContent: [
                  this.decimalFormatPipePipe.transform(
                    Number(this.packMaterialData.recycledContent)
                  ),
                  [Validators.min(0), Validators.max(100)],
                ],
                recyclableComponent: [null], // NEW DROPDOWN
              }),
              transportationDetailForm: this.formBuilder.group({
                Origin: [null],
                destination: [null],
                transportModeForLocation: [null],
                transportModeForDistance: [null],
                distanceManulaLocation: ['', [Validators.min(0.1), Validators.maxLength(100)]],
                distance: ['', [Validators.min(0.1), Validators.maxLength(100)]],
                customScenarioItem: [null],
              }),
              conversionDetailForm: this.formBuilder.group({
                conversion: [null],
                isRecommendedConversionProcess: [true],
                isAreabasedConversion: [false],
                isCustomConversion: [false],
                area: [
                  this.packMaterialData.areaBaseConversionProcess || '',
                  Validators.maxLength(100),
                ],
                converter: [null],
                country: [null],
                conversionCost: ['', Validators.maxLength(30)],
              }),
            });

            this.packageLevel = this.packMaterialData.packagingLevels.sort(
              (a: any, b: any) => a.packagingLevelId - b.packagingLevelId
            );
            this.recyclableComponentList = this.packMaterialData.recylcableComponentItems;
            this.organizationRecycleContent = this.packMaterialData.organizationRecycleContent;
            this.supplier = this.packMaterialData.suppliersItems;
            this.componentDataSource = this.packMaterialData?.componentDataSourceItems;
            this.materialItems = this.packMaterialData.materialItems;
            this.currrencyName = this.packMaterialData.currrencyName;
            this.customMaterialItems = this.packMaterialData.customMaterialItems;
            this.materialRegion = this.packMaterialData.materialRegion;
            this.transportModeItems = this.packMaterialData.transportModeItems;
            this.conversionProcessItems = this.packMaterialData.processItems;
            this.areaConversionItems = this.packMaterialData.areaConversionItems;
            this.conversionRegion = this.packMaterialData.conversionRegion;
            this.customTruckItems = this.packMaterialData.customTruckItems;
            this.customConversionItems = this.packMaterialData.customConversionItems;
            this.customtransportScenarioItems = this.packMaterialData.customtransportScenarioItems;
            this.CustomtransportScenarioId = this.packMaterialData?.customtransportScenarioId;
            this.checkAddCustomFreight = !!this.CustomtransportScenarioId ? true : false;
            this.scenarioId = this.packMaterialData.scenarioId;
            this.isCustomMaterial = this.packMaterialData.isCustomMaterial;
            this.isAreaBaseConversionProcess = this.packMaterialData.isAreaConversionProcess;
            this.isRecommendedConversionProcess =
              this.packMaterialData.isRecommendedConversionProcess;
            this.conversionProcessColumnDef =
              this.projectPackMaterialListDataGridService.getConversionProcessDataColumn();
            if (this.packMaterialData.conversionProcessItems.length > 0) {
              this.conversionProcessColumnDef.find((x: any) => x.headerName == 'Area').hide =
                this.packMaterialData.conversionProcessItems.filter(
                  (x: any) => x.areaBaseConversionProcess
                ).length > 0
                  ? false
                  : true;
              this.conversionProcessColumnDef.find((x: any) => x.headerName == 'Area').editable =
                this.packMaterialData.conversionProcessItems.filter(
                  (x: any) => x.areaBaseConversionProcess
                ).length > 0
                  ? true
                  : false;
            }
            this.isCustomConversion = this.packMaterialData.isCustomConversion;
            if (
              !this.isRecommendedConversionProcess &&
              !this.isAreaBaseConversionProcess &&
              !this.isCustomConversion
            ) {
              this.projectService.getAllOrganizationConversionProcess().subscribe((data: any) => {
                this.conversionNoSelectedProcessItems = data.data;
              });
            }
            this.customTransportList =
              this.packMaterialData.customTransoportScenarioDetailViewModels;
            this.isCostTrunOff = !this.packMaterialData.isCostTrunOff;
            this.conversionProcessColumnDef.find(
              (x: any) => x.headerName == 'Cost of conversion per kg'
            ).hide = !this.isCostTrunOff;
            this.materialCost = this.packMaterialData.materialCost;
            const materialDummyObj: any = {};
            materialDummyObj['id'] = this.packMaterialData.materialId;
            !this.packMaterialData.isAreaConversionProcess &&
              !this.packMaterialData.isCustomConversion &&
              this.getConversionProcess(materialDummyObj, true);

            this.supplierId = this.packMaterialData.materialSupplierId;
            this.componentDataSourceId = this.packMaterialData.componentDataSourceId;
            this.componentDetailForm = this.projectPackMaterialForm.controls['componentDetailForm'];
            this.materialDetailForm = this.projectPackMaterialForm.controls['materialDetailForm'];
            this.transportationDetailForm =
              this.projectPackMaterialForm.controls['transportationDetailForm'];
            this.conversionDetailForm =
              this.projectPackMaterialForm.controls['conversionDetailForm'];
            this.getPackageLevel();
            this.isCustomMaterial ? this.getCustomMaterialName() : null;
            this.getMaterialCountry();
            this.getConversionCountry();
            this.recycableComponent();
            this.setFormData();
            this.materialInfo();
            this.conversionProcessColumnDef.find(
              (x: any) => x.headerName == 'Country'
            ).cellRendererParams['conversionRegion'] = this.conversionRegion;
            this.conversionProcessColumnDef.find(
              (x: any) => x.headerName == 'Converter'
            ).cellRendererParams['supplier'] = this.supplier;
            !!this.CustomtransportScenarioId && this.getCustomFreight();
            this.projectFacde.bookMarkComponentDataBind(data);
            this.componentDetailForm.controls['componentName'].reset();
          }
        });
    }
  }
  setUnit(item: any) {
    if (!item.isOrigin) {
      return item.distance + ' ' + item.unit;
    } else {
      return item.distance;
    }
  }
  ngAfterViewInit() {
    if (!this.packMaterialData.isTourCompleted) this.triggerPopup();
  }

  onChangeSearchComponent(search: any) {
    this.componentDataSourceList = [];
    this.isComponentLoading = true;
    this.searchComponentDataSource(search);
  }

  onClearSearchComponent(event: any) {
    this.componentDataSourceId = null;
    this.isComponentLoading = false;
    this.componentDataSourceList = [];
    event?.stopPropagation();
    this.auto?.close();
  }

  searchComponentDataSource(search: string) {
    this.componentDataSourceList = search
      ? this.componentDataSource?.filter((item: any) =>
          item.name.toLowerCase().startsWith(search.toLowerCase())
        )
      : [];

    this.isComponentLoading = false;

    if (search === '' || !this.componentDataSourceList.length) {
      this.componentDataSourceId = null;
    }
  }

  selectedComponentDataSources(event: any) {
    if (!event.id) return;
    this.componentDataSourceId = event.id;
    this.selectedComponentDataSource = event.id;
  }

  onSelectComponentDataSource(event: any) {
    this.componentDataSourceId = event?.id ?? null;
  }

  ngOnDestroy(): void {
    this.subscriptionProjectMaterialData.unsubscribe();
    this.projectFacde.clearaddTransportScenarioForPackMaterialForConversion();
    this.searchSubject.complete();
  }

  private validateMaterialFeatures(payload: any): string[] {
    const validations: FeatureValidation[] = [
      {
        condition: payload.carbonNeutral || payload.fscCertification || payload.otherCertification,
        featureCode: FeatureCodes.MATERIAL_MATERIAL_CERTIFICATION,
        featureName: 'Material Certification',
      },
    ];

    return validateFeatures(validations, isFeatureEnabled);
  }
}
